import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import AboutModal from '../AboutModal';
import InfoModal from '../../ui/modals/InfoModal';
import ProjectForm from '../../projects/ProjectForm';
import ContactSupportModal from '../../help/ContactSupportModal';

export default function NavigationBarModals({
  showAbout,
  onAboutClose,
  showNoProjectModal,
  onNoProjectClose,
  showProjectFormModal,
  onHideProjectForm,
  onSaveProject,
  showDailyTypeModal,
  onHideDailyTypeModal,
  onDailyTypeSelect,
  showSummaryModal,
  onHideSummaryModal,
  onSummarySelect,
  showContactSupport,
  onHideContactSupport,
}) {
  return (
    <>
      <AboutModal show={showAbout} handleClose={onAboutClose} />

      <InfoModal
        show={showNoProjectModal}
        onHide={onNoProjectClose}
        title="No Active Project"
        body="Please activate a project from the Project Portfolio page before performing this action."
      />

      <ProjectForm
        show={showProjectFormModal}
        onHide={onHideProjectForm}
        onSave={onSaveProject}
        projectToEdit={null}
      />

      <Modal show={showDailyTypeModal} onHide={onHideDailyTypeModal} centered>
        <Modal.Header closeButton style={{ backgroundColor: '#2d5f3f', color: 'white' }}>
          <Modal.Title>Select Daily Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-grid gap-2">
            <Button size="lg" onClick={() => onDailyTypeSelect('survey')} style={{ backgroundColor: '#2d5f3f', borderColor: '#2d5f3f', color: 'white' }}>Survey Daily</Button>
            <Button size="lg" onClick={() => onDailyTypeSelect('drilling')} style={{ backgroundColor: '#d87f33', borderColor: '#d87f33', color: 'white' }}>Drilling Daily</Button>
            <Button size="lg" onClick={() => onDailyTypeSelect('recording')} style={{ backgroundColor: '#ffc107', borderColor: '#ffc107', color: 'white' }}>Recording Daily</Button>
            <Button size="lg" onClick={() => onDailyTypeSelect('management')} style={{ backgroundColor: '#003366', borderColor: '#003366', color: 'white' }}>Management & Logistics</Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHideDailyTypeModal}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSummaryModal} onHide={onHideSummaryModal} centered>
        <Modal.Header closeButton style={{ backgroundColor: '#2d5f3f', color: 'white' }}>
          <Modal.Title>Select Summary Area</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-grid gap-2">
            <Button size="lg" onClick={() => onSummarySelect('survey')} style={{ backgroundColor: '#2d5f3f', borderColor: '#2d5f3f', color: 'white' }}>Survey Summary</Button>
            <Button size="lg" onClick={() => onSummarySelect('drilling')} style={{ backgroundColor: '#d87f33', borderColor: '#d87f33', color: 'white' }}>Drilling Summary</Button>
            <Button size="lg" onClick={() => onSummarySelect('recording')} style={{ backgroundColor: '#ffc107', borderColor: '#ffc107', color: 'white' }}>Recording Summary</Button>
            <Button size="lg" onClick={() => onSummarySelect('management')} style={{ backgroundColor: '#003366', borderColor: '#003366', color: 'white' }}>Management Summary</Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHideSummaryModal}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      <ContactSupportModal show={showContactSupport} onHide={onHideContactSupport} />
    </>
  );
}
